import React from "react";
import "./RoutineBanner.css";

const RoutineBanner = () => {
  return (
    <div className="routine-banner">
      <div className="routine-left">
        <h1 className="hero-title">Your Daily Routine</h1>
        <p className="hero-desc">Discover products for daily care.</p>
      </div>

      <div className="routine-right">
        <img
          src="https://wonder-theme-beauty.myshopify.com/cdn/shop/files/preview_images/cc2494dc8cde4dcfbbcd7cf208d20cec.thumbnail.0000000000_600x.jpg?v=1709587862"
          alt="Daily routine"
        />
      </div>
    </div>
  );
};

export default RoutineBanner;